import React from 'react';
import { Text } from '@gasbuddy/react-components';

const EnsureDelivery = () => (
  <Text centered>
    To ensure delivery to your inbox, please add
    {' '}
    <b>noreply@gasbuddybusiness.io</b>
    {' '}
    to your address book, contacts, or safe senders list.
  </Text>
);

export default EnsureDelivery;
